import api from './axiosInstance';

const resumeService = {
  getResumes: () => api.get('/resumes'),
  getResume: (id) => api.get(`/resumes/${id}`),
  createResume: (data) => api.post('/resumes', data),
  updateResume: (id, data) => api.put(`/resumes/${id}`, data),
  deleteResume: (id) => api.delete(`/resumes/${id}`),
  generateSummary: (id) => api.post(`/resumes/${id}/generate-summary`),
  getLatestDraft: () => api.get('/resumes')
};

export default resumeService;